import React from "react";
import { Link } from "react-router-dom";
import { Col, Button, Container, Form, Row } from "reactstrap";

const landrickTeam = () => {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="justify-content-center">
            <Col className="col-12">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-4">
                  Our rates for developer from landrick team
                </h4>
                <p className="para-desc mx-auto text-muted mb-0">
                  Start working with{" "}
                  <span className="text-primary fw-bold">
                    Landrick
                  </span>{" "}
                  that can provide everything you need to generate awareness,
                  drive traffic, connect.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={4} md={6} className="mt-4 pt-2">
              <div className="card pricing pricing-primary business-rate border-0 p-4 rounded-md shadow">
                <div className="card-body p-0">
                  <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">
                    Basic
                  </span>
                  <h2 className="fw-bold mb-0 mt-3">$9.00</h2>
                  <p className="text-muted">Per Month</p>

                  <p className="text-muted">
                    All the basics for businesses that are just getting started.
                  </p>

                  <ul className="list-unstyled pt-3 border-top">
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Full Access
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Source Files
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      1 Domain Free
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                  </ul>

                  <div className="mt-4 d-grid">
                    <Link to="#" className="btn btn-primary">
                      Buy Now
                    </Link>
                    <p className="text-muted mt-3 mb-0">
                      *No credit card required
                    </p>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={4} md={6} className="mt-4 pt-2">
              <div className="card pricing pricing-primary business-rate border-0 p-4 rounded-md shadow">
                <div className="ribbon ribbon-right ribbon-warning overflow-hidden">
                  <span className="text-center d-block shadow small h6">
                    Best
                  </span>
                </div>
                <div className="card-body p-0">
                  <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">
                    Business
                  </span>
                  <h2 className="fw-bold mb-0 mt-3">$39.00</h2>
                  <p className="text-muted">Per Month</p>

                  <p className="text-muted">
                    Better for growing businesses that want more customers.
                  </p>

                  <ul className="list-unstyled pt-3 border-top">
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Full Access
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Source Files
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      1 Domain Free
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                  </ul>

                  <div className="mt-4 d-grid">
                    <Link to="#" className="btn btn-primary">
                      Buy Now
                    </Link>
                    <p className="text-muted mt-3 mb-0">
                      *No credit card required
                    </p>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={4} md={6} className="mt-4 pt-2">
              <div className="card pricing pricing-primary business-rate border-0 p-4 rounded-md shadow">
                <div className="card-body p-0">
                  <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">
                    Enterprise
                  </span>
                  <h2 className="fw-bold mb-0 mt-3">$79.00</h2>
                  <p className="text-muted">Per Month</p>

                  <p className="text-muted">
                    Advanced features for pros who need more customization.
                  </p>

                  <ul className="list-unstyled pt-3 border-top">
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Full Access
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Source Files
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      1 Domain Free
                    </li>
                    <li className="h6 text-muted mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Enhanced Security
                    </li>
                  </ul>

                  <div className="mt-4 d-grid">
                    <Link to="#" className="btn btn-primary">
                      Buy Now
                    </Link>
                    <p className="text-muted mt-3 mb-0">
                      *No credit card required
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="mt-100 mt-60">
          <Row className="justify-content-center">
            <Col className="col-12 text-center">
              <div className="section-title">
                <h4 className="title mb-4">
                  Want to be among the first to find out?
                </h4>
                <p className="text-muted para-desc mx-auto">
                  Start working with{" "}
                  <span className="text-primary fw-bold">Landrick</span>{" "}
                  that can provide everything you need to generate awareness,
                  drive traffic, connect.
                </p>

                <div className="subcribe-form mt-4 pt-2">
                  <Form>                   
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="rounded-pill border"
                        required
                        placeholder="E-mail :"
                      />
                      <Button type="submit" color="primary" className="btn btn-pills">
                        Get Started
                      </Button>                    
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );  
};
export default landrickTeam;
